export default {
  // 车牌号
  SORTCODE: () => {
    return [
      '京',
      '津',
      '冀',
      '晋',
      '蒙',
      '辽',
      '吉',
      '黑',
      '沪',
      '苏',
      '浙',
      '皖',
      '闽',
      '赣',
      '鲁',
      '豫',
      '鄂',
      '湘',
      '粤',
      '桂',
      '琼',
      '渝',
      '川',
      '贵',
      '云',
      '藏',
      '陕',
      '甘',
      '青',
      '宁',
      '新',
      '台',
      '港']
  },
  // 车辆状态
  CAR_STATUS_DICT: () => {
    return {
      1: '正常',
      0: '停用',
    }
  },
  // 车辆属性
  CAR_ATTRIBUTE_DICT: () => {
    return {
      1: '个人',
      2: '公司',
    }
  },
  // 车辆采购方式
  CAR_PROCUREMENT_DICT: () => {
    return {
      1: '购买',
      2: '租用',
    }
  },
  // 车辆颜色
  CAR_COLOR_DICT: () => {
    return {
      1: '黑色',
      2: '白色',
      3: '红色',
      4: '银色',
      5: '蓝色',
      6: '棕色',
      7: '绿色',
      8: '灰色',
      9: '黄色',
      10: '橙色',
      11: '紫色',
      12: '粉色',
      13: '金色',
      100: '其他',
    }
  },
  // 车辆能源类型
  ENERGY_TYPE_DICT: () => {
    return {
      1: '汽油',
      2: '柴油',
      3: '电(以电能驱动的汽车)',
      4: '混合油',
      5: '天然气',
      6: '液化石油气',
      7: '甲醇',
      8: '乙醇',
      9: '太阳能',
      10: '混合动力',
      100: '其他',
    }
  },
  // 车辆类型
  CAR_TYPE_DICT: () => {
    return {
      1: '大型汽车',
      2: '小型汽车',
      3: '专用汽车',
      4: '特种车',
      5: '有轨电车',
      6: '无轨电车',
      7: '电瓶车',
      8: '三轮摩托车',
      9: '二轮摩托车',
      100: '其他',
    }
  },
  // 服务类型
  CAR_SERVER_TYPE_DICT: () => {
    return {
      1: '网络预约出租车',
      2: '巡游出租车',
      3: '私人小客车合乘',
    }
  },
  // 车辆检修状态
  CAR_FIX_STATE_DICT: () => {
    return {
      0: '未检修',
      1: '已检修',
      2: '未知',
    }
  },
  // 车辆年度审核状态
  CAR_CHECK_STATE_DICT: () => {
    return {
      0: '未年审',
      1: '年审合格',
      2: '年审不合格',
    }
  },
  // 车辆维护类型
  MAIN_TAIN_TYPE_DICT: () => {
    return {
      1: '保养',
      2: '维修',
      3: '年检',
      10: '其他',
    }
  },
  // 车辆使用性质，暂不用
  NATURE_OF_VEHICLE_USE: () => {
    return {
      1: '家庭自用汽车',
      2: '非营业客车',
      3: '营业客车',
      4: '城市公交客车',
      5: '公路客运客车',
      6: '出租',
      7: '租赁客车',
      8: '非营业货车',
      9: '营业货车',
      10: '特种车',
    }
  },
  // 车辆使用性质，正在使用
  CAR_USE_DICT: () => {
    return {
      1: '营运',
      2: '非营运',
    }
  },
  // 库存状态
  OUT_INT_STATE: () => {
    return {
      0: '库外',
      1: '库内',
    }
  },
  // 出入库类型
  OUT_INT_TYPE: () => {
    return {
      1: '出库',
      2: '入库',
      3: '采购入库',
    }
  },
  // 出入库来源
  OUT_INT_SOURCE_TYPE: () => {
    return {
      1: '租赁订单',
      5: '换车单',
    }
  },
  // 客户标签
  CUSTOM_TYPE: () => {
    return {
      1: '车辆标签',
      2: '客户标签',
    }
  },

  // 车辆状态
  CAR_STATE: () => {
    return {
      10: '待处理',
      20: '待租',
      30: '备车',
      40: '已租',
    }
  },
  // 车辆基本状态信息
  CAR_MESSAGE: () => {
    return {
      1: '信息待补齐',
      2: '信息待提交',
      3: '审核中',
      4: '信息完整',
    }
  },
  ENERGY_TYPE_LIST: () => {
    return {
      1: '汽油',
      3: '纯电',
      10: '混合动力',
      100: '其它',
    }
  },
  // 车辆外观状态
  CAR_APPEARANCE_DICT: () => {
    return {
      1: '正常',
      2: '异常',
      3: '裂痕',
      4: '脱落',
      5: '划伤',
      6: '凹陷',
      7: '丢失',
    }
  },
  // 车辆底盘状态
  CAR_CHASSIS_DICT: () => {
    return {
      1: '正常',
      2: '异常',
      3: '裂痕',
      4: '脱落',
      5: '划伤',
      6: '凹陷',
      7: '丢失',
    }
  },
  // 车辆处置方式
  CAR_DISPOSE_METHOD: () => {
    return {
      1: '退回车源方',
      2: '个人购买',
      3: '公司回购',
      4: '保险赔付',
      5: '其他',
    }
  },
  // 电池冷却类型
  VEHICLE_COOLING_MODE: () => {
    return {
      0: '自然冷却',
      1: '风冷',
      2: '液冷',
      3: '直冷',
    }
  },
}
